const vO453 = {};
module.exports = {
  "UTILS.math.*": ["num action()"],
  "UTILS.randInt": ["num action()"],
  "UTILS.randFloat": ["num action()"],
  "UTILS.getDir2D": ["num action()"],
  "UTILS.getDir3D": ["obj action()", vO453.coord],
  "UTILS.getDist2D": ["num action()"],
  "UTILS.getDist3D": ["num action()"],
  "UTILS.anglDst": ["num action()"],
  "UTILS.hexFromHue": ["str action()"],
  "UTILS.invertHex": ["str action()"],
  "UTILS.HEXtoRGB": ["obj action()", vO453.rgb],
  "UTILS.RGBtoHEX": ["str action()"],
  "UTILS.toLower": ["str action()"],
  "UTILS.toUpper": ["str action()"],
  "UTILS.truncateTxt": ["str action()"],
  "UTILS.replaceText": ["str action()"],
  "UTILS.textContains": ["bool action()"],
  "TIME.now": ["num action()"],
  "TIME.fixedDelta": ["num action()"],
  "TIME.getReadable": ["str action()"],
  "INPUTS.keyDown": ["bool action()"],
  "INPUTS.mousePos": ["obj action()", vO453.coord],
  "INPUTS.mouseMovement": ["obj action()", vO453.coord],
  "INPUTS.mousePosOverlay": ["obj action()", vO453.coord],
  "UI.addDIV": ["str action()"],
  "UI.addImage": ["str action()"],
  "UI.moveDIV": ["str action()"],
  "UI.getDIVText": ["str action()"],
  "UI.getSize": ["obj action()", vO453.size],
  "UI.getProp": ["str action()"],
  "SETTINGS.get": ["str action()"],
  "SETTINGS.list": ["str action()"],
  "OVERLAY.getSize": ["obj action()", vO453.size],
  "OVERLAY.measureText": ["num action()"],
  "COOKIES.load": ["str action()"],
  "COOKIES.has": ["bool action()"],
  "NETWORK.send": ["bool action()"],
  "NETWORK.broadcast": ["bool action()"],
  "NFT.hasWallet": ["bool action()"],
  "NFT.ownedAssets": ["obj[] action()", vO453.nft],
  "PLAYERS.list": ["obj[] action()", vO453.player],
  "PLAYERS.getSelf": ["obj action()", vO453.player],
  "PLAYERS.findByID": ["obj action()", vO453.player],
  "SCENE.add*": ["obj action()", vO453.obj3D],
  "SCENE.posToScreen": ["obj action()"],
  "AI.list": ["obj[] action()", vO453.AI],
  "AI.spawn": ["obj action()", vO453.AI],
  "RAYCAST.from": ["obj action()", vO453.RAYCASTOB],
  "OBJECTS.getPathNodes": ["obj[] action()", vO453.node],
  "OBJECTS.list": ["obj[] action()", vO453.obj3D],
  "SOUND.play*": ["obj action()", vO453.sound],
  "PLATFORM.isClient": ["bool action()"],
  "PLATFORM.isBrowser": ["bool action()"],
  "PLATFORM.isMobile": ["bool action()"],
  "CAMERA.getObj": ["obj action()"],
  "CONFIG.getHost": ["obj action()", vO453.player]
};